// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const CardsetterMarkSvg = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#27AAE1" d="M39 4.787L60.213 26 39 47.213 17.787 26z" />
      <path fill="#67A9DB" d="M60.213 26H17.787L39 47.213z" />
      <path fill="#00A651" d="M83.214 50L62 71.212 40.787 49.999 62 28.786z" />
      <path fill="#49AD7C" d="M62 71.213V28.786L40.787 50z" />
      <g>
        <path
          fill="#F15A29"
          d="M38.999 95.212L17.785 74 39 52.786l21.213 21.213z"
        />
        <path fill="#EF7C56" d="M17.785 73.999h42.427L38.999 52.786z" />
      </g>
    </g>
  </svg>
);
